const T_PREFIX = "text-editor";

export const editorTrns = {
  linkPrompt: `${T_PREFIX}.link-prompt`,
};
